import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ConfigurationService } from '../configuration/configuration.service';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { BreadcrumbNavigationService } from '../breadcrumb-navigation/breadcrumb-navigation.service';
@Injectable({
    providedIn: 'root'
})
export class RouteManagementService  {
    private _allowedRoutes: string[];
    constructor(
        private _router: Router,
        private _configService: ConfigurationService,
        private _breadcrumbService: BreadcrumbNavigationService,
        private _localizeRouterService: LocalizeRouterService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        this._configService.$siteSettings.subscribe((data) => {
            if (data) {
                const _routeSettings = data.find((item) => item.key === 'routes');
                this._allowedRoutes = _routeSettings ? _routeSettings.value.split(',') : [];
                let _urlSegment = route.url[0].path;
                if (route.url[1]?.path === 'reset-password') {
                    _urlSegment = route.url[0].path + '/' + route.url[1].path;
                }
                if (this._allowedRoutes.length > 0 && !this._allowedRoutes.find((x) => x.toLowerCase() === _urlSegment.toLowerCase())) {
                    const translatedPath = this._localizeRouterService.translateRoute('/' + 'page-not-found');
                    this._router.navigate([translatedPath], { skipLocationChange: true }).then(() => {
                        // this._breadcrumbService.initBreadcrumb();
                    });
                    return false;
                }
            }
            return true;
        });

        return true;
    }
}
